import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {setFilterDialogList} from 'entities/messages'
import {useDebounce} from 'shared/hooks'
import {Search} from 'shared/ui/icons'
import {CircleXMark} from './icon/icons'
import styles from './styles.module.scss'

export const SearchDialogsMobile = () => {
  const dispatch = useDispatch()
  const [isFocused, setIsFocused] = useState(false)
  const [value, setValue] = useState('')
  const search = useDebounce(value)

  useEffect(() => {
    dispatch(setFilterDialogList(search))
  }, [search, dispatch, setFilterDialogList])

  return (
    <div className={styles.wrapper}>
      <div className={styles.search}>
        <div className={styles.searchIcon}>
          <Search />
        </div>
        <input
          type='text'
          placeholder='Search'
          className={styles.searchInput}
          onFocus={() => setIsFocused(true)}
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
        {isFocused && value
          ? <div className={styles.clearSearch} onClick={() => setValue('')}><CircleXMark /></div>
          : null}
      </div>
      {isFocused ? <div className={styles.cancel} onClick={() => setIsFocused(false)}>Cancel</div> : null}
    </div>
  )
}
